import React, { memo } from 'react'
import LogoLoop from './LogoLoop'

import imgJasonL from '../images/reviews/jason-lorenti.jpg'
import imgMianArif from '../images/reviews/mian-arif.jpg'
import seanmurphy from '../images/reviews/sean-murphy.png'
import imgSyedWaqas from '../images/reviews/syed-waqas.jpeg'

const REVIEWS = [
  {
    name: 'Sean Murphy',
    role: 'Director, Application & Cloud Development',
    company: 'ORR Protection USA',
    avatar: seanmurphy,
    initials: 'SM',
    color: '#0061bb',
    text: "We're incredibly impressed with Visiomate's services. Their knowledge and experience of Odoo, .NET development, and third-party integration has revolutionized our system. Their professionalism, expertise, and dedication were evident throughout the project. We highly recommend their services to anyone seeking reliable development solutions.",
  },
  {
    name: 'Mian Arif Hussain',
    role: 'CEO',
    company: 'Hummak Engineering Pakistan',
    avatar: imgMianArif,
    initials: 'MA',
    color: '#1b2d8e',
    text: 'Our AX 2012 system underwent a remarkable transformation with the help of Visiomate. Their expertise and dedication delivered outstanding results, significantly improving our operations. Highly recommended!',
  },
  {
    name: 'Syed Waqas',
    role: 'CEO',
    company: 'ZiePie USA',
    avatar: imgSyedWaqas,
    initials: 'SW',
    color: '#5a3d9e',
    text: "Working closely with Visiomate across multiple industries, including Education, Travel, and Power BI projects, has been an invaluable experience. Their expertise spans diverse sectors, and their ability to deliver exceptional results remains consistent across each project. Their professionalism, adaptability, and commitment to excellence make them a trusted partner.",
  },
  {
    name: 'Muzammil Jamil',
    role: 'Manager IT',
    company: 'Sapphire Pakistan',
    avatar: null,
    initials: 'MJ',
    color: '#0e3869',
    text: "Visiomate's has a very dedicated team that helped complete many projects that enhanced the ERP solution when I was in Hush Puppies. They won my trust, and I would easily suggest them for D365 support work.",
  },
  {
    name: 'Jason Lorenti',
    role: 'Principal Solution Architect',
    company: 'EvolvedOffice USA',
    avatar: imgJasonL,
    initials: 'JL',
    color: '#006d5b',
    text: "EvolvedOffice's product underwent significant enhancement thanks to its close collaboration with Visiomate's team. Their expertise and dedication brought innovative solutions, driving product improvement. We greatly value our partnership and look forward to achieving more together.",
  },
]

const Stars = () => (
  <div className="rv-stars">
    {[1, 2, 3, 4, 5].map(i => (
      <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#f0cd17">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
)

/**
 * Pattern C — testimonial marquee.
 *
 * Replaces a one-at-a-time carousel that advanced on a 6s setInterval, which
 * re-rendered React every six seconds for the life of the page whether or not
 * anyone had scrolled to it. The marquee shows every testimonial at once,
 * moving, and runs on the same CSS mechanism as the client strip: a duplicated
 * track translated by exactly one sequence width, paused by IntersectionObserver
 * when off-screen, and rendered static under prefers-reduced-motion.
 *
 * ATTRIBUTED CONTENT IS FROZEN. Every quote, name, role and company below is
 * carried through verbatim from the carousel. The cards move; the words do not
 * change. Do not edit the `text`, `name`, `role` or `company` of any entry.
 *
 * No arrows and no dots: with all five in a continuous track there is no
 * discrete state to step through, and the cards bleeding off both edges is what
 * signals there is more to see.
 */
const ReviewCard = ({ r }) => (
  <article className="rv-mq-card">
    <div className="rv-mq-card__quote" aria-hidden="true">
      <svg width="34" height="27" viewBox="0 0 40 32" fill="#f0cd17" opacity="0.9">
        <path d="M0 32V19.2C0 8.533 6.4 2.133 19.2 0l2.133 3.733C14.4 5.333 10.667 8.533 10.667 14.4H18.667V32H0ZM21.333 32V19.2C21.333 8.533 27.733 2.133 40.533 0l2.133 3.733c-6.933 1.6-10.666 4.8-10.666 10.667H40V32H21.333Z" />
      </svg>
    </div>
    <Stars />
    <p className="rv-mq-card__text">&ldquo;{r.text}&rdquo;</p>
    <div className="rv-mq-card__author">
      <div className="rv-mq-card__avatar" style={{ background: r.color }}>
        {r.avatar
          ? <img src={r.avatar} alt="" className="rv-mq-card__avatar-img" loading="lazy" decoding="async" width="48" height="48" />
          : <span className="rv-mq-card__avatar-initials">{r.initials}</span>}
      </div>
      <div className="rv-mq-card__author-info">
        <span className="rv-mq-card__name">{r.name}</span>
        <span className="rv-mq-card__role">{r.role}, {r.company}</span>
      </div>
    </div>
  </article>
)

const Reviews = () => (
  <section className="rv-section">
    <div className="rv-header">
      <h2 className="rv-heading">
        What Our Clients <span className="rv-heading__accent">Say</span>
      </h2>
      <p className="rv-sub">
        Don't just take our word for it. Here's what leaders from top companies say about working with Visiomate.
      </p>
    </div>

    <div className="rv-marquee">
      <LogoLoop
        logos={REVIEWS.map(r => ({ node: <ReviewCard r={r} />, ariaLabel: `${r.name}, ${r.company}` }))}
        renderItem={item => item.node}
        speed={38}
        direction="left"
        gap={24}
        pauseOnHover
        ariaLabel="Client testimonials"
      />
    </div>
  </section>
)

export default memo(Reviews)
